<template>
  <div style="margin:0;padding:0;width:100%;">

    <!-- Role + Date row -->
    <v-row class="mt-2">
      <v-col cols="4" sm="4" class="pb-n5 pt-2">
        <v-autocomplete
          outlined
          label="Role"
          v-model="formData.roleid"
          :items="roleList"
          dense
          clearable
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row class="mt-n4">
      <v-col cols="4" sm="4" class="pb-n5 pt-2">
        <v-text-field
          outlined
          :label="$t('columns.fromdate')"
          type="date"
          v-model="formData.fromdate"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="4" sm="4" class="pb-n5 pt-2">
        <v-text-field
          outlined
          :label="$t('columns.untildate')"
          type="date"
          v-model="formData.untildate"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="4" sm="4" class="pb-n5 pt-2">
        <v-btn color="#fd9941" style="color:white;" @click="loadData">
          <v-icon small>mdi-reload</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <!-- Filter Criteria -->
    <v-row class="mt-n4">
      <v-col cols="12">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header class="blue--text">{{ $t('reportsparam.filtercriteria') }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row class="mt-3">
                <v-col cols="4" sm="4" class="pb-n4 mt-n2">
                  <v-autocomplete outlined :label="$t('columns.company')" v-model="formData.company" :items="companyList" dense clearable></v-autocomplete>
                </v-col>
                <v-col cols="4" sm="4" class="pb-n4 mt-n2">
                  <v-autocomplete outlined :label="$t('columns.branch')" v-model="formData.branch" :items="branchList" dense clearable></v-autocomplete>
                </v-col>
                <v-col cols="4" sm="4" class="pb-n4 mt-n2">
                  <v-autocomplete outlined :label="$t('columns.division')" v-model="formData.division" :items="divisionList" dense clearable></v-autocomplete>
                </v-col>
                <v-col cols="4" sm="4" class="pb-n4 mt-n4">
                  <v-autocomplete outlined :label="$t('columns.department')" v-model="formData.department" :items="departmentList" dense clearable></v-autocomplete>
                </v-col>
                <v-col cols="4" sm="4" class="pb-n4 mt-n4">
                  <v-autocomplete outlined :label="$t('columns.section')" v-model="formData.section" :items="sectionList" dense clearable></v-autocomplete>
                </v-col>
                <v-col cols="4" sm="4" class="pb-n4 mt-n4">
                  <v-autocomplete outlined :label="$t('columns.unit')" v-model="formData.unit" :items="unitList" dense clearable></v-autocomplete>
                </v-col>
                <v-col cols="4" sm="4" class="pb-n4 mt-n4">
                  <v-autocomplete outlined :label="$t('columns.employmenttype')" v-model="formData.employmentType" :items="emptypeList" dense clearable></v-autocomplete>
                </v-col>
                <v-col cols="4" sm="4" class="pb-n4 mt-n4">
                  <v-autocomplete outlined :label="$t('periodicincentivesetup.workdaygroup')" v-model="formData.workdaygroup" :items="workdaygrouplist" dense clearable></v-autocomplete>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>

    <!-- Show type radio -->
    <v-row class="mt-1">
      <v-col cols="12">
        <v-radio-group v-model="formData.showtype" @change="applyShowType" row>
          <v-radio :label="$t('processedattendancedatarecord.showall')" value="All"></v-radio>
          <v-radio :label="$t('processedattendancedatarecord.showexceptiononly')" value="Exception"></v-radio>
          <v-radio :label="$t('processedattendancedatarecord.showpendingrecordonly')" value="Pending"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>

    <!-- Action buttons + search + table -->
    <v-row align="center">
      <v-col cols="12" md="6" style="padding:0;">
        <v-btn class="mr-3 mt-3 ml-4" color="#6ACB9A" style="color:white;" @click="approveSelected">
          {{ $t('processedattendancedatarecord.approveselected') }}
        </v-btn>
        <v-btn class="mt-3" color="#6ACB9A" style="color:white;" @click="updatePending">
          {{ $t('processedattendancedatarecord.updateselectedaspending') }}
        </v-btn>
      </v-col>
      <v-col cols="12" md="6" style="padding:10px 0 0 0;">
        <v-toolbar flat>
          <v-spacer></v-spacer>
          <button type="button" class="export-icon-btn export-icon-pdf mr-2" @click="printPDF" title="Export PDF">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 13h2a2 2 0 0 1 0 4H9v-4z"/><path d="M15 13h1a2 2 0 0 1 0 4h-1"/><line x1="15" y1="17" x2="17" y2="17"/></svg>
            PDF
          </button>
          <button type="button" class="export-icon-btn export-icon-csv mr-2" @click="getCSV" title="Export CSV">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>
            CSV
          </button>
          <div class="gv-search" style="align-self:center; margin-left:8px;">
            <svg class="gv-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <input v-model="search" type="text" placeholder="Search..." class="gv-search-input" />
          </div>
        </v-toolbar>
      </v-col>
    </v-row>

    <!-- Edit Dialog -->
    <v-dialog v-model="editDialog" max-width="800px">
      <v-card v-if="editItem">
        <v-card-title>{{ $t('processedattendancedatarecord.attendancedataitem') }}</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="4" class="pb-n5 mb-n8">
                <v-autocomplete outlined dense :label="$t('columns.status')" v-model="editItem.statusid" :items="statusList"></v-autocomplete>
              </v-col>
              <v-col cols="4" class="pb-n5 mb-n8">
                <v-text-field outlined dense readonly :label="$t('columns.date')" v-model="editItem.shiftdate" background-color="#ffeab2" append-icon=""></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" class="pb-n5">
                <v-text-field outlined dense readonly :label="$t('workhourspayitemmappingsetup.selectdaytype')" v-model="editItem.daytypecode" background-color="#ffeab2" append-icon=""></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-n5 mt-n8">
                <v-text-field outlined dense readonly :label="$t('columns.name')" :value="editItem.psnname + ' ' + editItem.staffcode + ' ' + editItem.compnycode" background-color="#ffeab2" append-icon=""></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" class="pb-n5 mt-n8">
                <v-text-field outlined dense readonly :label="$t('columns.staffid')" v-model="editItem.staffcode" background-color="#ffeab2"></v-text-field>
              </v-col>
              <v-col cols="4" class="pb-n5 mt-n8">
                <v-text-field outlined dense readonly :label="$t('columns.company')" v-model="editItem.compnycode" background-color="#ffeab2" append-icon=""></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="8" class="pb-n5 mt-n8">
                <v-text-field outlined dense readonly :label="$t('staffdailyrosterrecord.shift')" v-model="editItem.shiftcode" background-color="#ffeab2" append-icon=""></v-text-field>
              </v-col>
              <v-col cols="4" class="pb-n5 mt-n8">
                <v-text-field outlined dense readonly label="Shift Code" v-model="editItem.shiftcode" background-color="#ffeab2"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" class="pb-n5 mt-n8">
                <v-text-field outlined dense readonly :label="$t('processedattendancedatarecord.intime')" type="time" v-model="editItem.intime" background-color="#ffeab2" append-icon=""></v-text-field>
              </v-col>
              <v-col cols="4" class="pb-n5 mt-n8">
                <v-text-field outlined dense readonly :label="$t('processedattendancedatarecord.outtime')" type="time" v-model="editItem.outtime" background-color="#ffeab2" append-icon=""></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" class="pb-n5 mt-n8">
                <v-text-field outlined dense readonly :label="$t('processedattendancedatarecord.workhours')" type="number" v-model="editItem.workhrs" background-color="#ffeab2"></v-text-field>
              </v-col>
              <v-col cols="4" class="pb-n5 mt-n8">
                <v-text-field outlined dense readonly :label="$t('setupforshift.othours')" type="number" v-model="editItem.othrs" background-color="#ffeab2"></v-text-field>
              </v-col>
              <v-col cols="4" class="pb-n5 mt-n8">
                <v-text-field outlined dense readonly :label="$t('processedattendancedatarecord.preapprovedothours')" type="number" v-model="editItem.preaprothrs" background-color="#ffeab2"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" class="pb-n5 mt-n8">
                <v-text-field outlined dense :label="$t('processedattendancedatarecord.workhourstopay')" v-model="editItem.workhrspay"></v-text-field>
              </v-col>
              <v-col cols="4" class="pb-n5 mt-n8">
                <v-text-field outlined dense :label="$t('processedattendancedatarecord.othourstopay')" v-model="editItem.othrspay"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" class="pb-n5 mt-n8">
                <v-text-field outlined dense readonly :label="$t('processedattendancedatarecord.shiftallw')" v-model="editItem.sftallwpayitemcode" background-color="#ffeab2"></v-text-field>
              </v-col>
              <v-col cols="4" class="pb-n5 mt-n8">
                <v-text-field outlined dense readonly :label="$t('processedattendancedatarecord.otallw')" v-model="editItem.otallwpayitemcode" background-color="#ffeab2"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" class="pb-n5 mt-n8">
                <v-text-field outlined dense readonly :label="$t('leave')" v-model="editItem.leavecode" background-color="#ffeab2"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="mt-n8">
                <v-text-field outlined dense :label="$t('columns.remark')" v-model="editItem.remark"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeEditDialog">{{ $t('button.cancel') }}</v-btn>
          <v-btn color="green" text @click="saveRecord">{{ $t('button.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div style="overflow-x:auto; width:100%; margin-top:8px;">
      <v-data-table
        :search="search"
        :headers="tabHeader"
        :items="dataItems"
        class="elevation-1"
        dense
      >
        <template v-slot:[`header.isSelectedAll`]="{}">
          <v-checkbox v-model="isSelectedAll" dense @change="selectAll"></v-checkbox>
        </template>
        <template #item="{ item }">
          <tr :class="item.IsException ? 'ExceptionClass' : ''">
            <td><v-checkbox v-model="item.isSelected" dense @change="checkAllChecked"></v-checkbox></td>
            <td>
              <v-icon small class="mr-1" @click="modifyItemHandler(item)">mdi-pen</v-icon>
              <v-icon small class="ml-1" @click="deleteItemHandler(item)">mdi-delete</v-icon>
            </td>
            <td>{{ item.transtatus }}</td>
            <td>{{ item.shiftdate }}</td>
            <td>{{ item.daytypecode }}</td>
            <td>{{ item.staffcode }}</td>
            <td>{{ item.psnname }}</td>
            <td>{{ item.shiftcode }}</td>
            <td>{{ item.intime }}</td>
            <td>{{ item.outtime }}</td>
            <td>{{ item.inshifthrs }}</td>
            <td>{{ item.workhrs }}</td>
            <td>{{ item.othrs }}</td>
            <td>{{ item.preaprothrs }}</td>
            <td>{{ item.workhrspay }}</td>
            <td>{{ item.othrspay }}</td>
            <td>{{ item.leavecode }}</td>
            <td>{{ item.sftallwpayitemcode }}</td>
            <td>{{ item.otallwpayitemcode }}</td>
            <td>{{ item.remark }}</td>
          </tr>
        </template>
      </v-data-table>
    </div>

  </div>
</template>

<script>
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';

export default {
  data() {
    return {
      editDialog: false,
      editItem: null,
      statusList: [],
      search: '',
      isSelectedAll: false,
      dataItemList: [],
      dataItems: [],
      roleList: [],
      companyList: [],
      branchList: [],
      divisionList: [],
      departmentList: [],
      sectionList: [],
      unitList: [],
      emptypeList: [],
      workdaygrouplist: [],
      formData: {
        roleid: null,
        fromdate: moment().format('YYYY-MM-DD'),
        untildate: moment().format('YYYY-MM-DD'),
        showtype: 'All',
        company: null, branch: null, division: null,
        department: null, section: null, unit: null,
        employmentType: null, workdaygroup: null,
      },
      tabHeader: [
        { text: '', value: 'isSelectedAll', sortable: false, width: '50px' },
        { text: 'Actions', value: 'actions', sortable: false, width: '70px' },
        { text: this.$t('columns.status'),       value: 'transtatus',        sortable: true },
        { text: this.$t('columns.date'),          value: 'shiftdate',         width: '110px', sortable: false },
        { text: this.$t('setuprestdaypatternsetup.daytype'), value: 'daytypecode', width: '90px', sortable: false },
        { text: this.$t('columns.staffid'),       value: 'staffcode',         width: '100px', sortable: false },
        { text: this.$t('columns.name'),          value: 'psnname',           width: '160px', sortable: false },
        { text: this.$t('staffdailyrosterrecord.shift'), value: 'shiftcode',  width: '90px',  sortable: false },
        { text: this.$t('processedattendancedatarecord.intime'),   value: 'intime',   width: '80px',  sortable: false },
        { text: this.$t('processedattendancedatarecord.outtime'),  value: 'outtime',  width: '80px',  sortable: false },
        { text: this.$t('processedattendancedatarecord.inshifthours'), value: 'inshifthrs', width: '90px', sortable: false },
        { text: this.$t('processedattendancedatarecord.workhours'),    value: 'workhrs',    width: '90px', sortable: false },
        { text: this.$t('setupforshift.othours'),                      value: 'othrs',      width: '80px', sortable: false },
        { text: this.$t('processedattendancedatarecord.preapprovedothours'), value: 'preaprothrs', width: '100px', sortable: false },
        { text: this.$t('processedattendancedatarecord.workhourstopay'), value: 'workhrspay', width: '100px', sortable: false },
        { text: this.$t('processedattendancedatarecord.othourstopay'),   value: 'othrspay',   width: '100px', sortable: false },
        { text: this.$t('leave'),                                        value: 'leavecode',  width: '80px',  sortable: false },
        { text: this.$t('processedattendancedatarecord.shiftallw'),      value: 'sftallwpayitemcode', width: '100px', sortable: false },
        { text: this.$t('processedattendancedatarecord.otallw'),         value: 'otallwpayitemcode',  width: '100px', sortable: false },
        { text: this.$t('columns.remark'),                               value: 'remark',     sortable: false },
      ],
    };
  },

  computed: {
    staffId() { return this.$store.getters.staffId; },
    userId()  { return this.$store.getters.userId; },
  },

  methods: {
    loadData() {
      const payload = Object.assign({}, this.formData, { ownerstaffid: this.staffId });
      this.$store.dispatch('post', { url: '/ss/attendance/mystaff/processeddata', payload })
        .then(res => {
          this.dataItemList = [];
          this.dataItems = [];
          this.isSelectedAll = false;
          (res.data.rec || []).forEach(r => {
            let IsException = false;
            if ((!r.intime || !r.outtime || !r.workhrs) && r.daytypecode === 'N' && !r.leavecode) IsException = true;
            const d = {
              id: r.id, statusid: r.statusid, transtatus: r.transtatus,
              shiftdate: moment(r.shiftdate).format('YYYY-MM-DD'),
              daytypeid: r.daytypeid, daytypecode: r.daytypecode,
              staffid: r.staffid, staffcode: r.staffcode, psnname: r.psnname, compnycode: r.compnycode,
              shiftid: r.shiftid, shiftcode: r.shiftcode, shifthours: r.shifthours,
              intime:  r.intime  ? moment(r.intime).format('HH:mm')  : '',
              outtime: r.outtime ? moment(r.outtime).format('HH:mm') : '',
              inshifthrs: r.inshifthrs, workhrs: r.workhrs, othrs: r.othrs,
              preaprothrs: r.preaprothrs, workhrspay: r.workhrspay, othrspay: r.othrspay,
              leavetypeid: r.leavetypeid,
              leavecode: r.leavestatus === 'PENDING' ? '*' + r.leavecode : r.leavecode,
              sftallwpayitemid: r.sftallwpayitemid, sftallwpayitemcode: r.sftallwpayitemcode,
              otallwpayitemid: r.otallwpayitemid, otallwpayitemcode: r.otallwpayitemcode,
              remark: r.remark, stamp: r.stamp, action: 2,
              IsException, isSelected: false,
            };
            this.dataItemList.push(d);
            this.dataItems.push(d);
          });
          this.applyShowType(this.formData.showtype);
        })
        .catch(err => console.error(err));
    },

    applyShowType(type) {
      if (type === 'Exception') this.dataItems = this.dataItemList.filter(r => r.IsException);
      else if (type === 'Pending') this.dataItems = this.dataItemList.filter(r => r.transtatus === 'PENDING');
      else this.dataItems = this.dataItemList;
    },

    selectAll(val) { this.dataItems.forEach(r => { r.isSelected = val; }); },
    checkAllChecked() {
      this.isSelectedAll = this.dataItems.length > 0 && this.dataItems.every(r => r.isSelected);
    },

    approveSelected() {
      const selected = this.dataItems.filter(r => r.isSelected);
      if (!selected.length) return;
      this.$store.dispatch('post', { url: '/processedattendancedata/updatetoapproved', payload: { data: selected, userid: this.userId } })
        .then(() => this.loadData()).catch(err => console.error(err));
    },

    updatePending() {
      const selected = this.dataItems.filter(r => r.isSelected);
      if (!selected.length) return;
      this.$store.dispatch('post', { url: '/processedattendancedata/updatetopending', payload: { data: selected, userid: this.userId } })
        .then(() => this.loadData()).catch(err => console.error(err));
    },

    printPDF() {
      const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a3' });
      const head = [
        { title: this.$t('columns.status'), dataKey: 'transtatus' },
        { title: this.$t('columns.date'), dataKey: 'shiftdate' },
        { title: this.$t('setuprestdaypatternsetup.daytype'), dataKey: 'daytypecode' },
        { title: this.$t('columns.staffid'), dataKey: 'staffcode' },
        { title: this.$t('columns.name'), dataKey: 'psnname' },
        { title: this.$t('staffdailyrosterrecord.shift'), dataKey: 'shiftcode' },
        { title: this.$t('processedattendancedatarecord.intime'), dataKey: 'intime' },
        { title: this.$t('processedattendancedatarecord.outtime'), dataKey: 'outtime' },
        { title: this.$t('processedattendancedatarecord.workhours'), dataKey: 'workhrs' },
        { title: this.$t('setupforshift.othours'), dataKey: 'othrs' },
        { title: this.$t('processedattendancedatarecord.workhourstopay'), dataKey: 'workhrspay' },
        { title: this.$t('processedattendancedatarecord.othourstopay'), dataKey: 'othrspay' },
        { title: this.$t('leave'), dataKey: 'leavecode' },
        { title: this.$t('columns.remark'), dataKey: 'remark' },
      ];
      doc.autoTable(head, this.dataItems);
      doc.save('MyStaff_Attendance.pdf');
    },

    objectToCSV(data) {
      if (!data.length) return '';
      const headers = Object.keys(data[0]);
      const rows = data.map(r => headers.map(h => `"${('' + r[h]).replace(/"/g, '\\"')}"`).join(','));
      return [headers.join(','), ...rows].join('\n');
    },

    getCSV() {
      const data = this.dataItems.map(r => ({
        [this.$t('columns.status')]: r.transtatus,
        [this.$t('columns.date')]: r.shiftdate,
        [this.$t('setuprestdaypatternsetup.daytype')]: r.daytypecode,
        [this.$t('columns.staffid')]: r.staffcode,
        [this.$t('columns.name')]: r.psnname,
        [this.$t('staffdailyrosterrecord.shift')]: r.shiftcode,
        [this.$t('processedattendancedatarecord.intime')]: r.intime,
        [this.$t('processedattendancedatarecord.outtime')]: r.outtime,
        [this.$t('processedattendancedatarecord.workhours')]: r.workhrs,
        [this.$t('setupforshift.othours')]: r.othrs,
        [this.$t('processedattendancedatarecord.workhourstopay')]: r.workhrspay,
        [this.$t('processedattendancedatarecord.othourstopay')]: r.othrspay,
        [this.$t('leave')]: r.leavecode,
        [this.$t('columns.remark')]: r.remark,
      }));
      const blob = new Blob([decodeURIComponent('%ef%bb%bf'), this.objectToCSV(data)], { type: 'text/csv;charset=utf-8;' });
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(blob);
      a.download = 'MyStaff_Attendance.csv';
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
    },

    modifyItemHandler(item) {
      this.editItem = Object.assign({}, item);
      this.editDialog = true;
    },

    deleteItemHandler(item) {
      if (!confirm(`Delete attendance record for ${item.staffcode} on ${item.shiftdate}?`)) return;
      this.$store.dispatch('delete', { url: '/processedattendancedata/' + item.id })
        .then(() => this.loadData())
        .catch(err => console.error(err));
    },

    saveRecord() {
      this.$store.dispatch('put', {
        url: '/processedattendancedata/' + this.editItem.id,
        payload: Object.assign({}, this.editItem, { userid: this.userId }),
      })
        .then(() => { this.closeEditDialog(); this.loadData(); })
        .catch(err => console.error(err));
    },

    closeEditDialog() {
      this.editDialog = false;
      this.editItem = null;
    },

    loadDropdowns() {
      const load = (url, list, textKey, valueKey) => {
        this.$store.dispatch('get', { url }).then(res => {
          this[list] = res.data.rec.map(r => ({ text: r[textKey], value: r[valueKey] }));
        }).catch(err => console.error(err));
      };
      load('/company/all',                'companyList',      'compnyname',  'compnycode');
      load('/branch/all',                 'branchList',       'brchname',    'brchcode');
      load('/division/all',               'divisionList',     'divnname',    'divncode');
      load('/department/all',             'departmentList',   'deptname',    'deptcode');
      load('/section/all',                'sectionList',      'sectioname',  'sectiocode');
      load('/unit/all',                   'unitList',         'unitname',    'unitcode');
      load('/emptype/all',                'emptypeList',      'emptypedesc', 'emptype');
      load('/groupp_grouppb_workday/all', 'workdaygrouplist', 'valuedesc',   'valuecode');

      this.$store.dispatch('get', { url: `/ss/attendance/myroles/${this.staffId}` })
        .then(res => { this.roleList = res.data.rec || []; })
        .catch(err => console.error(err));

      this.$store.dispatch('get', { url: '/leave/status' })
        .then(res => {
          this.statusList = (res.data.rec || [])
            .filter(r => r.transtatus === 'APPROVED' || r.transtatus === 'PENDING')
            .map(r => ({ text: r.transtatus, value: r.id }));
        })
        .catch(err => console.error(err));
    },
  },

  mounted() {
    this.loadDropdowns();
  },
};
</script>

<style>
.v-data-table tbody tr.ExceptionClass td { color: red !important; }
.gv-search { position: relative; display: inline-flex; align-items: center; }
.gv-search-icon { position: absolute; left: 8px; top: 50%; transform: translateY(-50%); pointer-events: none; }
.gv-search-input { padding: 5px 10px 5px 30px; border: 1.5px solid #E8EDF5; border-radius: 8px; font-size: 0.83rem; font-family: inherit; color: #1E293B; outline: none; width: 180px; background: #fff; }
.gv-search-input:focus { border-color: #4F6BFF; box-shadow: 0 0 0 3px rgba(79,107,255,0.10); }
</style>
